import useSWR from "swr";

import { Utils } from "../common/utils";
import { CoursesCatalogInterface, CustomOptionType, DomainCompetency, SectionsCatalogInterface } from "Stores/courseStore";

const clientConfigs = Utils.getEAIClientConfigs();


interface CourseCatalogResponse {
  data: CoursesCatalogInterface[];
  total: number;
  message: string;
}
interface UnmappedSectionResponse {
  data: SectionsCatalogInterface[];
  total: number;
  total_enabled?: number;
  total_filtered: number;
  // message: string;
}
interface SectionsResponse {
  data: CustomOptionType[];
  total: number;
  message: string;
}

interface IDataResponse<T> { 
  data: T;
}

export interface DomainCompetencyResponse {
  data: DomainCompetency[];
  code: number;
  message: string;
}

export interface CompetencyItem extends DomainCompetency {
  isOpen?: boolean;
  children: CompetencyItem[];
}


export function useGetCourseCatalog() {
    const {data, error, mutate} = useSWR<CourseCatalogResponse, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/course_catalog/`)
    return {
        data,
        error,
        mutate
    };
}

export function useGetCognitiveLevels() {
    const {data, error, mutate} = useSWR<IDataResponse<SectionsResponse>, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/curriculum_mapping/cognitive_level`)
    return {
        data,
        error,
        mutate
    };
}

export function useGetCLOs() {
    const {data, error, mutate} = useSWR<IDataResponse<SectionsResponse>, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/curriculum_mapping/curriculum_mapping_clos`)
    return {
        data,
        error,
        mutate
    };
}

export function useGetTeachingMethods() {
    const {data, error, mutate} = useSWR<IDataResponse<SectionsResponse>, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/curriculum_mapping/teaching_method`)
    return {
        data,
        error,
        mutate
    };
}

export function useGetUnmappedSections(page: number, name_search: string, pageSize = 10, sortBy = "", sortOrder = "") {
    let sortQuery = "";
    if (sortBy) {
        sortQuery = `&order=${sortBy}:${sortOrder || "asc"}`;
    }
  const { data, error, mutate, isLoading } = useSWR<IDataResponse<UnmappedSectionResponse>, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/course_catalog/unmapped_sections/?page_size=${pageSize}&page=${page}&name_search=${name_search}${sortQuery}`, {
      keepPreviousData: true
    })
  return {
        isLoading,
        data,
        error,
        mutate
    };
}

